import { createContext, useContext, useEffect, useState } from "react";

const RouteCtx = createContext({ segs: [], path: "/" });
export const useRoute = () => useContext(RouteCtx);

export function navigate(to, { replace = false } = {}) {
  if (replace) window.history.replaceState({}, "", to);
  else window.history.pushState({}, "", to);
  window.dispatchEvent(new Event("flow:navigate"));
  window.scrollTo(0, 0);
}

export function RouteProvider({ children }) {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const sync = () => setPath(window.location.pathname);
    window.addEventListener("popstate", sync);
    window.addEventListener("flow:navigate", sync);
    return () => {
      window.removeEventListener("popstate", sync);
      window.removeEventListener("flow:navigate", sync);
    };
  }, []);

  const segs = path.split("/").filter(Boolean);
  return <RouteCtx.Provider value={{ path, segs }}>{children}</RouteCtx.Provider>;
}

/** <Link to="/invoices">…</Link> — keeps cmd-click and middle-click working. */
export const Link = ({ to, children, className, style, onClick }) => (
  <a
    href={to}
    className={className}
    style={style}
    onClick={(e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      onClick?.(e);
      navigate(to);
    }}
  >
    {children}
  </a>
);
